import React from 'react';
import { Platform, StyleSheet, TextInput } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import Color from './Color';

export default class Composer extends React.Component {
  render() {
    return (
      <TextInput
        testID={this.props.placeholder}
        accessible
        accessibilityLabel={this.props.placeholder}
        placeholder={this.props.placeholder}
        placeholderTextColor={COLOR.textLight}
        multiline={this.props.multiline}
        onChangeText={this.props.onTextChanged}
        onSelectionChange={this.props.onSelectionChange}
        style={[styles.textInput, this.props.textInputStyle]}
        autoFocus={this.props.textInputAutoFocus}
        value={this.props.text}
        enablesReturnKeyAutomatically
        underlineColorAndroid="transparent"
        keyboardAppearance={this.props.keyboardAppearance}
        {...this.props.textInputProps}
      />
    );
  }
}

const styles = StyleSheet.create({
  textInput: {
    flex: 1,
    height: 40,
    marginLeft: 10,
    fontSize: 16,
    lineHeight: 24,
    backgroundColor: COLOR.altContrast,
    borderRadius: 5,
    padding: 10,
    marginTop: Platform.select({
      ios: 10,
      android: 0,
      web: 10,
    }),
    marginBottom: Platform.select({
      ios: 10,
      android: 10,
      web: 0,
    }),
    ...(__WEB__
      ? {
          marginRight: 10,
        }
      : {}),
  },
});

Composer.defaultProps = {
  text: '',
  placeholderTextColor: Color.defaultProps,
  textInputProps: null,
  multiline: true,
  textInputStyle: {},
  textInputAutoFocus: false,
  keyboardAppearance: 'default',
  onTextChanged: () => {},
};
